import { fetchContactList } from './fetchContactList';
import { sendSumoLog } from './sumoLogger';
import { updateError } from '../../store';

export const deleteNotifUser = async (token, userId, dispatch) => {
  const requestUrl = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/user/${userId}`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'DELETE',
      headers,
    });

    const body = await data.json();

    if (!data.ok) {
      throw {
        message: `Failed To Delete Notif User ${userId} with status: ${data.status} and message: ${body.message}`,
        code: data.status,
      };
    }

    fetchContactList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;
    sendSumoLog(
      'deleteNotifUser',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );
    updateError(
      {
        message: `Can not delete a user with notifictions attached.`,
        errorType: 'UnprocessableEntity',
      },
      dispatch
    );
  }
};
